import { Box, Stack, Typography, useTheme } from "@mui/material";
import { FlagFilledIcon } from "components";
import { SelectableChip } from "components/chip";
import CustomQuillEditor from "components/quill/QuillEditor";
// import { CustomQuillEditor } from "pages/modules/control-center/configurations/components/service-desk-templates/tabs/component";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { PriorityData } from "shared/data";

export const PriorityDescriptionSection = () => {
  const theme = useTheme();
  const { control, formState, getValues } = useFormContext();

  const PRIORITY_COLORS: Record<string, string> = {
    critical: theme.palette.error.main,
    high: theme.palette.warning.main,
    medium: theme.palette["warning-minor"].main,
    low: theme.palette.primitive.neutrals.neutral["700"] ?? "#828282",
  };
  const PRIORITY_BG_COLORS: Record<string, string> = {
    critical: theme.palette.error.tint || "",
    high: theme.palette.warning.tint || "",
    medium: theme.palette["warning-minor"].tint || "",
    low: theme.palette.primitive.neutrals.neutral["100"] || "",
  };

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "8px",
        backgroundColor: "#FFF",
      }}
    >
      <Stack
        sx={{
          p: "12px 16px",
          gap: "16px",
        }}
      >
        <Typography variant="subtitle1">Select priority</Typography>
        <Stack direction={"row"} sx={{ gap: "16px", flexWrap: "wrap" }}>
          <Controller
            control={control}
            name={"priority"}
            defaultValue={[]}
            render={({ field }) => (
              <React.Fragment>
                {PriorityData.map((priority) => (
                  <SelectableChip
                    key={priority.label}
                    label={priority.label}
                    isSelected={field.value === priority.value}
                    onClick={() => {
                      field.onChange(priority.value);
                    }}
                    containerStyle={{
                      minWidth: "120px",
                      padding: "8px",
                      gap: "4px",
                      justifyContent: "flex-start",
                      backgroundColor:
                        field.value === priority.value
                          ? PRIORITY_BG_COLORS[priority.value]
                          : theme.palette.neutral.main,
                      border: `1px solid ${field.value === priority.value ? PRIORITY_COLORS[priority.value] : theme.palette.neutral["010"]}`,
                      boxShadow:
                        field.value === priority.value
                          ? "none"
                          : "0px 0px 4px 0px #0000000F, 0px 0px 2px 0px #0000000A",
                      color: theme.palette.lightBg.main,
                    }}
                    shape="rounded"
                    startIcon={
                      <FlagFilledIcon
                        htmlColor={PRIORITY_COLORS[priority.value] || "white"}
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                    }
                    isShowTickWhenSelected={false}
                  />
                ))}
              </React.Fragment>
            )}
          />
        </Stack>
      </Stack>
      <Controller
        control={control}
        name={"description"}
        defaultValue={[]}
        render={({ field }) => (
          <CustomQuillEditor
            {...field}
            // isRequired
            error={formState.errors.description ? true : false}
            placeholder={"Add a description"}
            value={field.value}
            onChange={(value) => {
              field.onChange(value.value);
            }}
          />
        )}
      />
    </Box>
  );
};
